import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Badge} from 'reactstrap'
import ChevronLeft from 'react-feather/dist/icons/chevron-left.js'
import ChevronRight from 'react-feather/dist/icons/chevron-right.js'
import X from 'react-feather/dist/icons/x.js'
import Send from 'react-feather/dist/icons/send.js'
import Mail from 'react-feather/dist/icons/mail.js'
import Phone from 'react-feather/dist/icons/phone.js'
import Edit from 'react-feather/dist/icons/edit-2.js'

import BlueCheck from '../../../../../components/BlueCheck/BlueCheck.jsx'
import Date from '../../../../../../shared/components/Moment/Date.jsx'
import Picture from '../../../../../components/Picture/Picture.jsx'
import Skills from '../../../../../components/Skills/Skills.jsx'
import StateLabel from '../../../../../components/Offer/StateLabel/StateLabel.jsx'

import './OfferSearchSidePanel.scss'

const universes = ['Aucun', 'Achats & Supply', 'Finance', 'Ressources Humaines', 'Ingénierie']

export default class OfferSearchSidePanel extends PureComponent {
  static propTypes = {
    canApply: PropTypes.bool,
    canEdit: PropTypes.bool,
    fullLink: PropTypes.string,
    index: PropTypes.number.isRequired,
    isAdmin: PropTypes.bool,
    offer: PropTypes.object,
    onApply: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onPrev: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
  }

  static defaultProps = {
    canApply: false,
    canEdit: false,
    fullLink: null,
    isAdmin: false,
  }

  render() {
    const {canApply, canEdit, fullLink, index, isAdmin, offer, onApply, onClose, onEdit, onNext, onPrev, total} = this.props

    if (!offer) return null

    const smsSent = offer?.sms_ticket?.nb_sendings ?? 0

    return (
      <div className="offer-search-side-panel">
        <div className="offer-search-side-panel__overlay" onClick={onClose} />

        <div className="offer-search-side-panel__inner">
          <div className="offer-search-side-panel__header">
            {total > 1 ? (
              <div className="offer-search-side-panel__nav">
                <button type="button" className="btn btn-sm btn-outline-secondary btn-auto-width" onClick={onPrev}>
                  <ChevronLeft size={24} />
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary btn-auto-width" onClick={onNext}>
                  <ChevronRight size={24} />
                </button>
                <span className="offer-search-side-panel__count">{index + 1} / {total}</span>
              </div>
            ) : <div />}

            <button type="button" className="btn btn-sm btn-outline-secondary btn-auto-width offer-search-side-panel__close" onClick={onClose}>
              <X size={24} />
            </button>
          </div>

          <div className="offer-search-side-panel__identity">
            <div className="offer-search-side-panel__counters">
              {offer?.universe ? (
                <Badge color="secondary">{universes[offer.universe]}</Badge>
              ) : null}

              <StateLabel filled={offer.filled} locked={offer.locked} published={offer.published} />

              {offer.hasAnswer && !isAdmin ? (
                <BlueCheck hasTooltip tooltipOverlay="J'ai postulé" />
              ) : null}
            </div>

             <div className="offer-search-side-panel__informations">
              <h2 className="offer-search-side-panel__title">
                {offer?.title ?? ''}
                <span className="offer-search-side-panel__id">#{offer?.id}</span>
              </h2>

              {isAdmin && (
                <strong className="offer-search-side-panel__client">
                  Client : {offer?.client_name ?? 'N/A'}
                </strong>
              )}
            </div>

            <div className="offer-search-side-panel__state">
              {isAdmin && offer.nbOfferAnswer > 0 && (
                <Badge color="light">{offer.nbOfferAnswer} candidature(s)</Badge>
              )}
              {isAdmin && smsSent > 0 && (
                <Badge color="info">{smsSent} sms</Badge>
              )}
            </div>
          </div>

          <div className="offer-search-side-panel__actions">
            {canApply && (
              <button type="button" className="btn btn-secondary flex-grow-1 justify-content-center" onClick={() => onApply(offer)}>
                <Send size={16} />
                Postuler
              </button>
            )}

            {canEdit && (
              <button type="button" className="btn btn-outline-shy btn-auto-width justify-content-center" onClick={() => onEdit(offer)}>
                <Edit size={16} className="mb-1" />
                Éditer
              </button>
            )}
          </div>

          <ul className="offer-search-side-panel__grid">
            <li>
              <p>TJM</p>
              <strong>{offer?.tjm_text ?? 'Non précisé'}</strong>
            </li>

            <li>
              <p>Durée</p>
              <strong>{offer?.duration ?? 'Non précisé'}</strong>
            </li>

            <li>
              <p>Démarrage</p>
              <strong><Date date={offer?.start_date ?? null} /></strong>
            </li>

            <li>
              <p>Localisation</p>
              <strong>{offer?.city?.[0]?.departement ?? offer?.city?.[0]?.label ?? 'Non précisé'}</strong>
            </li>

            <li>
              <p>Expérience</p>
              <strong>{offer?.experiences ?? 'Non précisé'}</strong>
            </li>

            <li>
              <p>Secteur</p>
              <strong>{offer?.secteurs?.[0]?.name ?? 'Non précisé'}</strong>
            </li>
          </ul>

          {offer.keywords?.length ? (
            <div className="offer-search-side-panel__section">
              <h3>Compétences</h3>
              <Skills key={offer.id} list={offer.keywords} forceNoLink={true} />
            </div>
          ) : null}

          <div className="offer-search-side-panel__section">
            <h3>Description</h3>
            <div className="offer-search-side-panel__description" dangerouslySetInnerHTML={{__html: offer?.description ?? 'Sans description'}} />
          </div>

          {offer.manager && (
            <div className="offer-search-side-panel__section offer-search-side-panel__manager">
              <h3>Responsable de l'offre</h3>
              <div className="offer-search-side-panel__manager-content">
                <Picture
                  src={offer.manager?.image?.square ?? null}
                  alt={offer.manager.fullname}
                  className="offer-search-side-panel__manager-picture"
                />

                <div>
                  <strong>{offer.manager.fullname}</strong>
                  <p>
                    <Mail size={14} />&nbsp;
                    <a href={`mailto:${offer.manager.email}`}>{offer.manager.email}</a>
                  </p>
                  {offer.manager.tel && (
                    <p>
                      <Phone size={14} />&nbsp;
                      <a href={`tel:${offer.manager.tel}`}>{offer.manager.tel}</a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {fullLink && (
            <div className="freelance-search-ia-side-panel__full-profile">
              <Link to={fullLink} className="btn btn-outline-secondary btn-block">
                Voir la fiche complète
              </Link>
            </div>
          )}
        </div>
      </div>
    )
  }
}
